import script from "./ResourcePdf.vue?vue&type=script&setup=true&lang=ts"
export * from "./ResourcePdf.vue?vue&type=script&setup=true&lang=ts"

import "./ResourcePdf.vue?vue&type=style&index=0&id=d7ba7a2e&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.32_vue@3.5.32_typescript@5.9.3__webpack@5.105.4/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d7ba7a2e"]])

export default __exports__